module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lepus/lep_vis-01837f53c4e0cc5e1ee6837b8dffa965.jpg";